import { render } from "./Redprompt.vue?vue&type=template&id=764aef83&scoped=true&ts=true"
import script from "./Redprompt.vue?vue&type=script&lang=ts"
export * from "./Redprompt.vue?vue&type=script&lang=ts"

import "./Redprompt.vue?vue&type=style&index=0&id=764aef83&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/production-Q-saas-plat-manage-vue/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764aef83"]])

export default __exports__